import React from 'react';
import Icon from 'components/AppIcon';

const KEYS = [
  { keys: ['←', '→', 'A', 'D'], label: 'Move' },
  { keys: ['↑', 'W', 'Space'], label: 'Jump' },
  { keys: ['P'], label: 'Pause' },
  { keys: ['R'], label: 'Restart' },
];

export default function KeyboardGuide() {
  return (
    <div className="rounded-xl p-4" style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)' }}>
      <div className="flex items-center gap-2 mb-3">
        <Icon name="Keyboard" size={16} color="var(--color-primary)" />
        <span className="font-caption text-sm font-semibold" style={{ color: 'var(--color-foreground)' }}>
          Controls
        </span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {KEYS?.map(({ keys, label }) => (
          <div key={label} className="flex items-center gap-2">
            <div className="flex gap-1 flex-wrap">
              {keys?.map(k => (
                <kbd
                  key={k}
                  className="px-1.5 py-0.5 rounded text-xs font-data font-semibold"
                  style={{ background: 'var(--color-muted)', color: 'var(--color-foreground)', border: '1px solid var(--color-border)', minWidth: 24, textAlign: 'center' }}
                >
                  {k}
                </kbd>
              ))}
            </div>
            <span className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}